import { createFileRoute } from '@tanstack/react-router'

// Bare /offers (no offer selected): the layout renders the full-width rail with its SlideInPanel closed,
// so this index match renders nothing into the (collapsed) detail Outlet. Selecting an offer navigates
// to `/offers/$offerId/report`.
export const Route = createFileRoute('/_app/offers/_list/')({})
